import { useState } from "react";

const hasTwoWords = (value) => value.trim().split(/\s+/).length >= 2;

export const useRiderSelection = ({ snackBarDialog }) => {
  const [riderOption, setRiderOption] = useState(0);
  const [openOtherPersonModal, setOpenOtherPersonModal] = useState(false);
  const [otherPersonName, setOtherPersonName] = useState("");
  const [otherPersonPhone, setOtherPersonPhone] = useState("");
  const [otherPersonPreview, setOtherPersonPreview] = useState({
    name: "",
    phone: "",
  });

  const handleRiderOptionChange = (event) => {
    const value = event.target.value;
    setRiderOption(value);
    if (value === 2) {
      setOpenOtherPersonModal(true);
      return;
    }
    setOtherPersonName("");
    setOtherPersonPhone("");
    setOtherPersonPreview({
      name: "",
      phone: "",
    });
  };

  const handleCloseOtherPersonModal = () => {
    setOpenOtherPersonModal(false);
  };

  const handleOpenOtherPersonModal = () => {
    setOpenOtherPersonModal(true);
  };

  const handleOtherPersonNameChange = (event) => {
    const value = event.target.value
      .toUpperCase()
      .trimStart()
      .replace(/\s+/g, " ");
    setOtherPersonName(value);
  };

  const handleOtherPersonPhoneChange = (event) => {
    setOtherPersonPhone(event.target.value.slice(0, 20));
  };

  const handleAcceptOtherPerson = () => {
    if (!hasTwoWords(otherPersonName)) {
      snackBarDialog("INGRESE NOMBRE Y APELLIDO", "error");
      return;
    }
    if (!otherPersonPhone.trim()) {
      snackBarDialog("INGRESE EL TELEFONO", "error");
      return;
    }
    setOtherPersonPreview({
      name: otherPersonName.trim(),
      phone: otherPersonPhone.trim(),
    });
    handleCloseOtherPersonModal();
  };

  const resetRiderSelection = () => {
    setRiderOption(0);
    setOpenOtherPersonModal(false);
    setOtherPersonName("");
    setOtherPersonPhone("");
    setOtherPersonPreview({
      name: "",
      phone: "",
    });
  };

  return {
    riderOption,
    openOtherPersonModal,
    otherPersonName,
    otherPersonPhone,
    otherPersonPreview,
    handleRiderOptionChange,
    handleCloseOtherPersonModal,
    handleOpenOtherPersonModal,
    handleOtherPersonNameChange,
    handleOtherPersonPhoneChange,
    handleAcceptOtherPerson,
    resetRiderSelection,
  };
};
